// GIWAHS Mock Data
// NOTE: All data below is FICTIONAL PLACEHOLDER DATA. Company names, suppliers,
// brand associations, certifications, and trust scores are mock content used for
// MVP demonstration only. No real factory-brand relationships are implied.
// Designed to be drop-in replaceable with a Supabase/PostgreSQL backend later.

export const SUPPLIER_TYPES = [
  'Direct Manufacturer',
  'OEM Factory',
  'ODM Factory',
  'Trading Company',
  'Sourcing Agent',
  'Wholesaler',
];

export const PRODUCT_CATEGORIES = [
  { slug: 'streetwear', name: 'Streetwear', count: 184 },
  { slug: 'workwear', name: 'Workwear', count: 92 },
  { slug: 'activewear', name: 'Activewear', count: 138 },
  { slug: 'caps-headwear', name: 'Caps & Headwear', count: 76 },
  { slug: 'footwear', name: 'Footwear', count: 112 },
  { slug: 'accessories', name: 'Accessories', count: 88 },
  { slug: 'denim', name: 'Denim', count: 64 },
  { slug: 'outerwear', name: 'Outerwear', count: 58 },
];

export const COUNTRIES = [
  'China', 'Vietnam', 'Bangladesh', 'India', 'Turkey',
  'Portugal', 'Italy', 'Pakistan', 'Indonesia', 'Mexico',
  'Cambodia', 'Morocco',
];

export const CERTIFICATIONS = [
  'ISO 9001', 'BSCI', 'WRAP', 'GOTS', 'OEKO-TEX',
  'Sedex SMETA', 'GRS', 'Fair Trade', 'ISO 14001', 'BCI',
];

export const SHIPPING_CAPABILITIES = ['Sea Freight', 'Air Freight', 'Rail', 'Express (DHL/FedEx)'];

export const VERIFICATION_BADGES = {
  business: { label: 'Business Verified', code: 'BV', description: 'Business registration validated by Giwahs intelligence.' },
  video: { label: 'Video Verified', code: 'VV', description: 'Facility tour video reviewed by Giwahs team.' },
  audit: { label: 'Factory Audited', code: 'FA', description: 'Third-party audit report on file.' },
  premium: { label: 'Premium Trusted Supplier', code: 'PT', description: 'Top-tier supplier with exceptional track record.' },
};

export const TRENDS = [
  { slug: 'tech-techwear', name: 'Tech Techwear', heat: 96, season: 'AW26' },
  { slug: 'gorpcore', name: 'Gorpcore Outdoor', heat: 88, season: 'AW26' },
  { slug: 'quiet-luxury', name: 'Quiet Luxury Basics', heat: 84, season: 'SS27' },
  { slug: 'workwear-revival', name: 'Workwear Revival', heat: 79, season: 'AW26' },
  { slug: 'recycled-denim', name: 'Recycled Denim', heat: 74, season: 'SS27' },
  { slug: 'oversized-cap', name: 'Oversized 5-Panel Caps', heat: 71, season: 'SS27' },
];

// Realistic-looking but FICTIONAL supplier dataset
export const SUPPLIERS = [
  {
    id: 'sup-001',
    slug: 'northgate-apparel-collective',
    name: 'Northgate Apparel Collective',
    tagline: 'Premium cut-and-sew specialists for elevated streetwear',
    type: 'Direct Manufacturer',
    country: 'Portugal',
    city: 'Porto',
    founded: 2008,
    employees: '180–240',
    trustScore: 94,
    responseRate: 98,
    responseTimeHours: 4,
    moqMin: 300,
    moqMax: 5000,
    leadTimeDays: '35–55',
    productionCapacityPerMonth: '120,000 units',
    categories: ['streetwear', 'outerwear'],
    specialties: ['Heavyweight Fleece', 'Garment Dyeing', 'Cut & Sew Knits'],
    certifications: ['ISO 9001', 'GOTS', 'OEKO-TEX', 'BSCI'],
    shipping: ['Sea Freight', 'Air Freight', 'Express (DHL/FedEx)'],
    exportMarkets: ['EU', 'UK', 'USA', 'Japan', 'Australia'],
    badges: ['business', 'video', 'audit', 'premium'],
    pricingIndicator: '$$$',
    heroImage: 'https://images.pexels.com/photos/4614227/pexels-photo-4614227.jpeg',
    gallery: [
      'https://images.pexels.com/photos/4614227/pexels-photo-4614227.jpeg',
      'https://images.unsplash.com/photo-1603189343302-e603f7add05a?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.pexels.com/photos/18541463/pexels-photo-18541463.jpeg',
    ],
    knownBrandAssociations: [
      { brand: 'NORTH/AXIS Studio', status: 'Verified', period: '2021–Present', source: 'Supplier-submitted contract excerpt' },
      { brand: 'Atelier Mira', status: 'Publicly Reported', period: '2019–2022', source: 'Industry trade publication' },
      { brand: 'House of Vanta', status: 'Unverified', period: 'Alleged 2018', source: 'Anonymous tip — not validated' },
      { brand: 'Carbon Folk Co.', status: 'Historical', period: '2014–2017', source: 'Archived press release' },
    ],
  },
  {
    id: 'sup-002',
    featured: true,
    featuredTier: 'spotlight',
    slug: 'shenzhen-vector-mfg',
    name: 'Shenzhen Vector Manufacturing',
    tagline: 'High-volume technical activewear and performance knits',
    type: 'OEM Factory',
    country: 'China',
    city: 'Shenzhen',
    founded: 2012,
    employees: '420–520',
    trustScore: 91,
    responseRate: 96,
    responseTimeHours: 3,
    moqMin: 500,
    moqMax: 20000,
    leadTimeDays: '30–50',
    productionCapacityPerMonth: '320,000 units',
    categories: ['activewear', 'streetwear'],
    specialties: ['Seamless Knitting', 'Sublimation Print', 'Moisture-Wicking Fabrics'],
    certifications: ['ISO 9001', 'BSCI', 'OEKO-TEX', 'GRS'],
    shipping: ['Sea Freight', 'Air Freight', 'Rail', 'Express (DHL/FedEx)'],
    exportMarkets: ['USA', 'EU', 'UK', 'South Korea', 'UAE'],
    badges: ['business', 'video', 'audit'],
    pricingIndicator: '$$',
    heroImage: 'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?auto=format&fit=crop&q=85',
    gallery: [
      'https://images.pexels.com/photos/4614227/pexels-photo-4614227.jpeg',
      'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?auto=format&fit=crop&q=85',
    ],
    knownBrandAssociations: [
      { brand: 'Velar Athletic', status: 'Verified', period: '2020–Present', source: 'Direct supplier confirmation' },
      { brand: 'Bridge Run Co.', status: 'Publicly Reported', period: '2022', source: 'LinkedIn case study' },
      { brand: 'Pulse Move Lab', status: 'Unverified', period: 'Alleged 2023', source: 'Forum mention — not validated' },
    ],
  },
  {
    id: 'sup-003',
    slug: 'dhaka-loomline-textiles',
    name: 'Dhaka Loomline Textiles',
    tagline: 'Scaled woven and knit production with sustainable practices',
    type: 'Direct Manufacturer',
    country: 'Bangladesh',
    city: 'Dhaka',
    founded: 2005,
    employees: '1,200–1,400',
    trustScore: 88,
    responseRate: 92,
    responseTimeHours: 6,
    moqMin: 1000,
    moqMax: 50000,
    leadTimeDays: '45–70',
    productionCapacityPerMonth: '650,000 units',
    categories: ['workwear', 'denim', 'streetwear'],
    specialties: ['Denim Washing', 'Heavy Twill', 'Cargo Construction'],
    certifications: ['WRAP', 'BSCI', 'Sedex SMETA', 'ISO 14001', 'GOTS'],
    shipping: ['Sea Freight', 'Air Freight'],
    exportMarkets: ['EU', 'USA', 'UK', 'Canada'],
    badges: ['business', 'audit', 'premium'],
    pricingIndicator: '$',
    heroImage: 'https://images.pexels.com/photos/18541463/pexels-photo-18541463.jpeg',
    gallery: [
      'https://images.pexels.com/photos/18541463/pexels-photo-18541463.jpeg',
      'https://images.pexels.com/photos/4614227/pexels-photo-4614227.jpeg',
    ],
    knownBrandAssociations: [
      { brand: 'Forge & Field', status: 'Verified', period: '2019–Present', source: 'Audit documentation' },
      { brand: 'Drift Denim Co.', status: 'Historical', period: '2012–2018', source: 'Public sustainability report' },
    ],
  },
  {
    id: 'sup-004',
    featured: true,
    featuredTier: 'boost',
    slug: 'hanoi-capworks-studio',
    name: 'Hanoi Capworks Studio',
    tagline: 'Headwear specialists — caps, beanies, bucket hats',
    type: 'ODM Factory',
    country: 'Vietnam',
    city: 'Hanoi',
    founded: 2015,
    employees: '90–130',
    trustScore: 86,
    responseRate: 94,
    responseTimeHours: 5,
    moqMin: 200,
    moqMax: 8000,
    leadTimeDays: '25–40',
    productionCapacityPerMonth: '85,000 units',
    categories: ['caps-headwear', 'accessories'],
    specialties: ['5-Panel Caps', 'Embroidery', 'Custom Closures'],
    certifications: ['BSCI', 'OEKO-TEX'],
    shipping: ['Sea Freight', 'Air Freight', 'Express (DHL/FedEx)'],
    exportMarkets: ['USA', 'EU', 'Australia', 'Japan'],
    badges: ['business', 'video'],
    pricingIndicator: '$$',
    heroImage: 'https://images.unsplash.com/photo-1521369909029-2afed882baee?auto=format&fit=crop&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1521369909029-2afed882baee?auto=format&fit=crop&q=85',
    ],
    knownBrandAssociations: [
      { brand: 'Crown Stack Goods', status: 'Verified', period: '2021–Present', source: 'Mutual NDA disclosure' },
      { brand: 'Skyline Brim', status: 'Publicly Reported', period: '2023', source: 'Trade fair directory listing' },
    ],
  },
  {
    id: 'sup-005',
    slug: 'istanbul-mercer-knit-house',
    name: 'Istanbul Mercer Knit House',
    tagline: 'Premium European-quality knitwear, fast turnarounds',
    type: 'Direct Manufacturer',
    country: 'Turkey',
    city: 'Istanbul',
    founded: 2010,
    employees: '220–280',
    trustScore: 92,
    responseRate: 97,
    responseTimeHours: 3,
    moqMin: 250,
    moqMax: 10000,
    leadTimeDays: '20–35',
    productionCapacityPerMonth: '180,000 units',
    categories: ['streetwear', 'outerwear', 'activewear'],
    specialties: ['Premium Knits', 'Mercerized Cotton', 'Acid Wash'],
    certifications: ['ISO 9001', 'GOTS', 'OEKO-TEX', 'BCI'],
    shipping: ['Sea Freight', 'Air Freight', 'Rail', 'Express (DHL/FedEx)'],
    exportMarkets: ['EU', 'UK', 'USA', 'Middle East'],
    badges: ['business', 'video', 'audit', 'premium'],
    pricingIndicator: '$$$',
    heroImage: 'https://images.unsplash.com/photo-1603189343302-e603f7add05a?crop=entropy&cs=srgb&fm=jpg&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1603189343302-e603f7add05a?crop=entropy&cs=srgb&fm=jpg&q=85',
    ],
    knownBrandAssociations: [
      { brand: 'Mercer & Vane', status: 'Verified', period: '2017–Present', source: 'Annual supplier statement' },
      { brand: 'Roan Knit Society', status: 'Publicly Reported', period: '2020–2024', source: 'Industry magazine feature' },
      { brand: 'Atlas Yarn Co.', status: 'Unverified', period: 'Alleged 2024', source: 'Anonymous community submission' },
    ],
  },
  {
    id: 'sup-006',
    slug: 'guangzhou-sole-foundry',
    name: 'Guangzhou Sole Foundry',
    tagline: 'Vulcanized & cup sole footwear specialist',
    type: 'OEM Factory',
    country: 'China',
    city: 'Guangzhou',
    founded: 2007,
    employees: '380–460',
    trustScore: 89,
    responseRate: 95,
    responseTimeHours: 4,
    moqMin: 600,
    moqMax: 25000,
    leadTimeDays: '40–65',
    productionCapacityPerMonth: '210,000 pairs',
    categories: ['footwear'],
    specialties: ['Vulcanized Soles', 'Leather Uppers', 'Custom Lasts'],
    certifications: ['ISO 9001', 'BSCI', 'OEKO-TEX'],
    shipping: ['Sea Freight', 'Air Freight', 'Express (DHL/FedEx)'],
    exportMarkets: ['USA', 'EU', 'Japan', 'South Korea'],
    badges: ['business', 'audit'],
    pricingIndicator: '$$',
    heroImage: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=85',
    ],
    knownBrandAssociations: [
      { brand: 'Tread Republic', status: 'Verified', period: '2018–Present', source: 'Public case study (consented)' },
      { brand: 'Pacer Sole Co.', status: 'Historical', period: '2010–2015', source: 'Archived supplier directory' },
    ],
  },
  {
    id: 'sup-007',
    slug: 'tirupur-circular-knits',
    name: 'Tirupur Circular Knits',
    tagline: 'Organic cotton specialists for premium basics',
    type: 'Direct Manufacturer',
    country: 'India',
    city: 'Tirupur',
    founded: 2011,
    employees: '300–360',
    trustScore: 90,
    responseRate: 96,
    responseTimeHours: 4,
    moqMin: 500,
    moqMax: 30000,
    leadTimeDays: '35–55',
    productionCapacityPerMonth: '260,000 units',
    categories: ['streetwear', 'activewear', 'accessories'],
    specialties: ['Organic Cotton', 'Reactive Dyeing', 'Tubular Knits'],
    certifications: ['GOTS', 'Fair Trade', 'OEKO-TEX', 'GRS', 'ISO 14001'],
    shipping: ['Sea Freight', 'Air Freight'],
    exportMarkets: ['EU', 'UK', 'USA', 'Australia', 'Canada'],
    badges: ['business', 'video', 'audit', 'premium'],
    pricingIndicator: '$$',
    heroImage: 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?auto=format&fit=crop&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?auto=format&fit=crop&q=85',
    ],
    knownBrandAssociations: [
      { brand: 'Verda Earth Goods', status: 'Verified', period: '2019–Present', source: 'GOTS chain-of-custody record' },
      { brand: 'Pure Frame Co.', status: 'Publicly Reported', period: '2022–2024', source: 'Sustainability white paper' },
    ],
  },
  {
    id: 'sup-008',
    slug: 'porto-rivetline-denim',
    name: 'Porto Rivetline Denim',
    tagline: 'Boutique denim atelier with vintage wash expertise',
    type: 'Direct Manufacturer',
    country: 'Portugal',
    city: 'Braga',
    founded: 2013,
    employees: '80–110',
    trustScore: 93,
    responseRate: 98,
    responseTimeHours: 3,
    moqMin: 150,
    moqMax: 3000,
    leadTimeDays: '40–60',
    productionCapacityPerMonth: '45,000 units',
    categories: ['denim', 'workwear'],
    specialties: ['Selvedge Denim', 'Laser Whiskering', 'Hand Distressing'],
    certifications: ['GOTS', 'OEKO-TEX', 'BCI'],
    shipping: ['Sea Freight', 'Air Freight', 'Express (DHL/FedEx)'],
    exportMarkets: ['EU', 'UK', 'USA', 'Japan'],
    badges: ['business', 'video', 'premium'],
    pricingIndicator: '$$$$',
    heroImage: 'https://images.unsplash.com/photo-1604176354204-9268737828e4?auto=format&fit=crop&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1604176354204-9268737828e4?auto=format&fit=crop&q=85',
    ],
    knownBrandAssociations: [
      { brand: 'Rivet & Rye', status: 'Verified', period: '2020–Present', source: 'Joint marketing collateral' },
      { brand: 'Six-Pocket Studio', status: 'Publicly Reported', period: '2023', source: 'Press release' },
    ],
  },
  {
    id: 'sup-009',
    featured: true,
    featuredTier: 'standard',
    slug: 'bandung-textile-bureau',
    name: 'Bandung Textile Bureau',
    tagline: 'Mid-volume cut-and-sew with strong accessory capabilities',
    type: 'Trading Company',
    country: 'Indonesia',
    city: 'Bandung',
    founded: 2016,
    employees: '60–90',
    trustScore: 78,
    responseRate: 88,
    responseTimeHours: 9,
    moqMin: 100,
    moqMax: 4000,
    leadTimeDays: '30–50',
    productionCapacityPerMonth: '38,000 units',
    categories: ['accessories', 'streetwear', 'caps-headwear'],
    specialties: ['Tote Bags', 'Beanies', 'Crew Knits'],
    certifications: ['BSCI', 'OEKO-TEX'],
    shipping: ['Sea Freight', 'Air Freight'],
    exportMarkets: ['Australia', 'EU', 'USA'],
    badges: ['business'],
    pricingIndicator: '$',
    heroImage: 'https://images.unsplash.com/photo-1605812860427-4024433a70fd?auto=format&fit=crop&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1605812860427-4024433a70fd?auto=format&fit=crop&q=85',
    ],
    knownBrandAssociations: [
      { brand: 'Sunset Drape Co.', status: 'Unverified', period: 'Alleged 2024', source: 'Buyer community post — not validated' },
    ],
  },
];

// Mock products
export const PRODUCTS = [
  {
    id: 'prd-001',
    slug: 'oversized-heavyweight-hoodie',
    name: 'Oversized Heavyweight Hoodie — 480gsm',
    category: 'streetwear',
    image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?auto=format&fit=crop&q=85',
    moq: 300,
    leadTime: '35–55 days',
    pricing: '$14.20–$22.80',
    suppliers: ['sup-001', 'sup-002', 'sup-005'],
    tags: ['Heavyweight Fleece', 'Garment Dyed'],
    sourcingRegions: ['Portugal', 'Turkey', 'China'],
  },
  {
    id: 'prd-002',
    slug: 'seamless-performance-tee',
    name: 'Seamless Performance Tee',
    category: 'activewear',
    image: 'https://images.unsplash.com/photo-1581087707458-6f33d3a5d6a8?auto=format&fit=crop&q=85',
    moq: 500,
    leadTime: '30–50 days',
    pricing: '$5.40–$9.80',
    suppliers: ['sup-002', 'sup-007'],
    tags: ['Seamless', 'Moisture-Wicking'],
    sourcingRegions: ['China', 'India'],
  },
  {
    id: 'prd-003',
    slug: 'unstructured-5-panel-cap',
    name: 'Unstructured 5-Panel Cap',
    category: 'caps-headwear',
    image: 'https://images.unsplash.com/photo-1521369909029-2afed882baee?auto=format&fit=crop&q=85',
    moq: 200,
    leadTime: '25–40 days',
    pricing: '$3.10–$6.40',
    suppliers: ['sup-004', 'sup-009'],
    tags: ['Embroidery', 'Custom Brim'],
    sourcingRegions: ['Vietnam', 'Indonesia'],
  },
  {
    id: 'prd-004',
    slug: 'selvedge-denim-trouser',
    name: 'Selvedge Denim Trouser — 14oz',
    category: 'denim',
    image: 'https://images.unsplash.com/photo-1604176354204-9268737828e4?auto=format&fit=crop&q=85',
    moq: 150,
    leadTime: '40–60 days',
    pricing: '$28.50–$48.00',
    suppliers: ['sup-008', 'sup-003'],
    tags: ['Selvedge', 'Vintage Wash'],
    sourcingRegions: ['Portugal', 'Bangladesh'],
  },
  {
    id: 'prd-005',
    slug: 'vulcanized-low-top-sneaker',
    name: 'Vulcanized Low-Top Sneaker',
    category: 'footwear',
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=85',
    moq: 600,
    leadTime: '40–65 days',
    pricing: '$12.80–$24.50',
    suppliers: ['sup-006'],
    tags: ['Vulcanized', 'Canvas Upper'],
    sourcingRegions: ['China'],
  },
  {
    id: 'prd-006',
    slug: 'organic-cotton-crewneck',
    name: 'Organic Cotton Crewneck',
    category: 'streetwear',
    image: 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?auto=format&fit=crop&q=85',
    moq: 500,
    leadTime: '35–55 days',
    pricing: '$8.20–$14.40',
    suppliers: ['sup-007', 'sup-001'],
    tags: ['GOTS Certified', 'Reactive Dyed'],
    sourcingRegions: ['India', 'Portugal'],
  },
  {
    id: 'prd-007',
    slug: 'heavyweight-canvas-cargo',
    name: 'Heavyweight Canvas Cargo Pant',
    category: 'workwear',
    image: 'https://images.unsplash.com/photo-1473966968600-fa801b3bbf26?auto=format&fit=crop&q=85',
    moq: 1000,
    leadTime: '45–70 days',
    pricing: '$11.40–$19.60',
    suppliers: ['sup-003', 'sup-008'],
    tags: ['12oz Canvas', 'Reinforced Stitch'],
    sourcingRegions: ['Bangladesh', 'Portugal'],
  },
  {
    id: 'prd-008',
    slug: 'mercerized-knit-polo',
    name: 'Mercerized Knit Polo',
    category: 'streetwear',
    image: 'https://images.unsplash.com/photo-1603189343302-e603f7add05a?crop=entropy&cs=srgb&fm=jpg&q=85',
    moq: 250,
    leadTime: '20–35 days',
    pricing: '$9.80–$16.20',
    suppliers: ['sup-005'],
    tags: ['Mercerized', 'Premium Knit'],
    sourcingRegions: ['Turkey'],
  },
  {
    id: 'prd-009',
    slug: 'recycled-nylon-tote',
    name: 'Recycled Nylon Tote Bag',
    category: 'accessories',
    image: 'https://images.unsplash.com/photo-1605812860427-4024433a70fd?auto=format&fit=crop&q=85',
    moq: 100,
    leadTime: '30–50 days',
    pricing: '$3.80–$7.20',
    suppliers: ['sup-009', 'sup-007'],
    tags: ['Recycled Nylon', 'GRS'],
    sourcingRegions: ['Indonesia', 'India'],
  },
  {
    id: 'prd-010',
    slug: 'technical-shell-jacket',
    name: 'Technical Shell Jacket',
    category: 'outerwear',
    image: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?auto=format&fit=crop&q=85',
    moq: 400,
    leadTime: '40–60 days',
    pricing: '$22.40–$38.90',
    suppliers: ['sup-001', 'sup-005'],
    tags: ['Waterproof', 'Sealed Seams'],
    sourcingRegions: ['Portugal', 'Turkey'],
  },
  {
    id: 'prd-011',
    slug: 'fleece-balaclava',
    name: 'Heavy Fleece Balaclava',
    category: 'accessories',
    image: 'https://images.unsplash.com/photo-1605773000056-bd3935bb24bd?auto=format&fit=crop&q=85',
    moq: 300,
    leadTime: '30–45 days',
    pricing: '$4.20–$7.80',
    suppliers: ['sup-004', 'sup-009'],
    tags: ['Polar Fleece', 'Tactical'],
    sourcingRegions: ['Vietnam', 'Indonesia'],
  },
  {
    id: 'prd-012',
    slug: 'compression-running-short',
    name: 'Compression Running Short',
    category: 'activewear',
    image: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&q=85',
    moq: 500,
    leadTime: '30–50 days',
    pricing: '$6.40–$11.20',
    suppliers: ['sup-002'],
    tags: ['Compression', 'Quick-Dry'],
    sourcingRegions: ['China'],
  },
];

// Helpers (would be DB queries later)
export const getSupplierBySlug = (slug) => SUPPLIERS.find(s => s.slug === slug);
export const getSupplierById = (id) => SUPPLIERS.find(s => s.id === id);
export const getProductBySlug = (slug) => PRODUCTS.find(p => p.slug === slug);

export const TRUST_SCORE_FACTORS = [
  { key: 'businessReg', label: 'Business Registration', weight: 18 },
  { key: 'certifications', label: 'Verified Certifications', weight: 22 },
  { key: 'responseRate', label: 'Response Performance', weight: 14 },
  { key: 'mediaUploads', label: 'Verified Factory Media', weight: 16 },
  { key: 'reviews', label: 'Buyer Reviews', weight: 14 },
  { key: 'verificationHistory', label: 'Verification History', weight: 16 },
];

export const SUSTAINABILITY_CERTS = ['GOTS', 'GRS', 'Fair Trade', 'OEKO-TEX', 'ISO 14001', 'BCI'];

// Featured placement / sponsorship tiers (PLACEHOLDER monetisation logic)
// IMPORTANT: Featured status is a PROMOTIONAL placement.
// It does NOT influence trust score, verification, or default sort order.
// Featured suppliers appear in a clearly labelled "Sponsored Placement" strip
// at the top of the Factory Directory — separate from the trust-sorted grid.
export const FEATURED_TIERS = {
  spotlight: {
    key: 'spotlight',
    label: 'Spotlight',
    monthlyUsd: 1200,
    placements: 'Top of Factory Directory + category landing pages + Intelligence brief sidebar',
    description: 'Highest-visibility tier. Appears across discovery surfaces.',
  },
  boost: {
    key: 'boost',
    label: 'Boost',
    monthlyUsd: 480,
    placements: 'Featured strip on Factory Directory only',
    description: 'Mid-tier promotional placement on the main directory.',
  },
  standard: {
    key: 'standard',
    label: 'Standard',
    monthlyUsd: 180,
    placements: 'Featured strip rotation (limited slots)',
    description: 'Entry-tier sponsored placement, rotated alongside other Standard listings.',
  },
};

export const getFeaturedSuppliers = () => SUPPLIERS.filter(s => s.featured === true);


export const BRAND_ASSOC_STATUSES = [
  { key: 'Verified', tone: 'success', description: 'Confirmed through documentation reviewed by Giwahs.' },
  { key: 'Publicly Reported', tone: 'neutral', description: 'Reported by public, attributable sources (press, trade publications).' },
  { key: 'Unverified', tone: 'warning', description: 'Reported but not independently validated. Treat with caution.' },
  { key: 'Historical', tone: 'muted', description: 'Past relationship; no longer active. Recorded for archival reference.' },
];
